module.exports = __webpack_public_path__ + "static/media/curation-video.89166496.mp4";